import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl, defineMessages } from 'react-intl';

import { Segment, Grid, Icon, Image, Modal } from 'semantic-ui-react';
import { Checkbox, Tooltip } from 'material-ui';

import { InfectionPC, Loading, ExamStep } from 'components';

import * as common from 'libs/commonFunc';
import * as commonVar from 'libs/commonVar';

import styles from './ExamListItem.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class ExamListItemPi extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { indexNo, itemNo, examListData, examSummaryData, selectedExamList, sendLogData } = this.props;
    // function
    const { handleSelectExamList } = this.props;

    // 피싱 유도 템플릿
    const isPhishing = 4 === examSummaryData.get('examType') ? true : false;

    // 메일 발송 실패
    const sendFail = !!examListData.get('sendError');
    // 훈련 메일 나눔 발송 (랜덤 발송)
    const sendReserve = !!examListData.get('sendReserve') && !examListData.get('send');
    // 메일발송 일시 정지
    const sendStop = !!examListData.get('isSuspend') && !examListData.get('send');
    let sendTooltip = defineMessages(formatMessage({ id: 'ExamListItem_4', defaultMessage: '발송' }));
    if (!!sendFail) {
      sendTooltip = defineMessages(formatMessage({ id: 'ExamListItem_20', defaultMessage: '발송 실패' }));
    } else if (!!sendStop) {
      sendTooltip = !!sendReserve
        ? '(' +
          defineMessages(formatMessage({ id: 'ExamListItem_27', defaultMessage: '발송 일시 정지' })) +
          ') ' +
          defineMessages(formatMessage({ id: 'ExamListItem_25', defaultMessage: '발송 예약' })) +
          ': ' +
          common.timeFormatFromUTCEpoch(examListData.get('sendReserve'))
        : defineMessages(formatMessage({ id: 'ExamListItem_27', defaultMessage: '발송 일시 정지' }));
    } else if (!!sendReserve && !sendStop) {
      sendTooltip =
        defineMessages(formatMessage({ id: 'ExamListItem_25', defaultMessage: '발송 예약' })) +
        ': ' +
        common.timeFormatFromUTCEpoch(examListData.get('sendReserve'));
    } else if (!!examListData.get('send')) {
      sendTooltip += ': ' + common.timeFormatFromUTCEpoch(examListData.get('send'));
    }
    const readTooltip =
      defineMessages(formatMessage({ id: 'ExamListItem_5', defaultMessage: '열람' })) +
      (examListData.get('read') ? ( examListData.get('readDeviceInfo') ? (
        ': ' + common.timeFormatFromUTCEpoch(examListData.get('read')) + ' [' + examListData.get('readDeviceInfo') + ']'
      ) : ': ' + common.timeFormatFromUTCEpoch(examListData.get('read')) ) + (examListData.get('readIp') ? ' '+ examListData.get('readIp') : '') : '') 
      ;
    const downTooltip =
      (isPhishing
        ? defineMessages(formatMessage({ id: 'ExamDetail_51', defaultMessage: '피싱 접속' })) 
        : defineMessages(formatMessage({ id: 'CtExamChart_5', defaultMessage: '파일 다운' }))) +
      (examListData.get('download') ? ': ' + common.timeFormatFromUTCEpoch(examListData.get('download')) + (examListData.get('downloadIp') ? ' '+ examListData.get('downloadIp') : '') : '' ) 
      ;
    const infectionTooltip =
      (isPhishing
        ? defineMessages(formatMessage({ id: 'ExamDetail_52', defaultMessage: '정보 유출' }))
        : defineMessages(formatMessage({ id: 'ExamListItem_6', defaultMessage: '감염' }))) +
      (examListData.get('infection') ? ': ' + common.timeFormatFromUTCEpoch(examListData.get('infection')) : '');
    const cureTooltip =
      defineMessages(formatMessage({ id: 'CtExamChart_8', defaultMessage: '치료' })) +
      (examListData.get('cure') ? ': ' + common.timeFormatFromUTCEpoch(examListData.get('cure')) : '');

    const stepText =
      (1 === examSummaryData.get('examType') &&
        2 === examSummaryData.getIn(['attachData', 'attachExamType']) &&
        !!examListData.get('cure') &&
        defineMessages(formatMessage({ id: 'CtExamChart_7', defaultMessage: '치료' }))) ||
      (!!examListData.get('infection') &&
        (isPhishing
          ? defineMessages(formatMessage({ id: 'ExamDetail_52', defaultMessage: '정보 유출' }))
          : defineMessages(formatMessage({ id: 'ExamListItem_6', defaultMessage: '감염' })))) ||
      ((2 & examListData.get('linkAttach') || isPhishing) &&
        !!examListData.get('download') &&
        (isPhishing
          ? defineMessages(formatMessage({ id: 'ExamDetail_51', defaultMessage: '피싱 접속' }))
          : defineMessages(formatMessage({ id: 'CtExamChart_6', defaultMessage: '다운' })))) ||
      (!!examListData.get('read') && defineMessages(formatMessage({ id: 'ExamListItem_5', defaultMessage: '열람' }))) ||
      (!!sendFail && defineMessages(formatMessage({ id: 'ExamListItem_20', defaultMessage: '발송 실패' }))) ||
      (!!sendStop && defineMessages(formatMessage({ id: 'ExamListItem_28', defaultMessage: '발송 정지' }))) ||
      (!!sendReserve &&
        !sendStop &&
        defineMessages(formatMessage({ id: 'ExamListItem_25', defaultMessage: '발송 예약' }))) ||
      (!!examListData.get('send') &&
        defineMessages(formatMessage({ id: 'ExamListItem_11', defaultMessage: '안전' }))) ||
      (!!examListData.get('target') &&
        defineMessages(formatMessage({ id: 'ExamListItem_12', defaultMessage: '준비' })));

    const existEdu = examListData.get('eduByTarget') > 0;
    let eduTooltip = defineMessages(formatMessage({ id: 'Edu_27', defaultMessage: '연결된 교육 없는 대상자' }));
    let eduText = '-';
    let existPlayEdu = false;

    if (existEdu) {
      eduText = defineMessages(formatMessage({ id: 'Edu_31', defaultMessage: '학습' }));

      if (examListData.get('eduAfter') > 0) {
        eduTooltip =
          defineMessages(formatMessage({ id: 'Edu_28', defaultMessage: '학습 완료' })) +
          ': ' +
          examListData.get('eduAfter') +
          ' / ' +
          examListData.get('eduByTarget');
      } else if (examListData.get('eduPlay') > 0) {
        eduTooltip =
          defineMessages(formatMessage({ id: 'Edu_29', defaultMessage: '학습 진행중' })) +
          ': ' +
          examListData.get('eduPlay') +
          ' / ' +
          examListData.get('eduByTarget');
      } else {
        eduTooltip = defineMessages(formatMessage({ id: 'Edu_30', defaultMessage: '학습 안함' }));
      }

      if (examListData.get('eduPlay') > 0 || examListData.get('eduAfter') > 0) {
        existPlayEdu = true;
      }
    }

    const InnerComponent = (
      <Grid.Row className={cx('examPi', { 'deleted-target': !examListData.get('isEnable') })} textAlign="center">
        <Grid.Column className={cx('cell-targetName')} textAlign="left">
          <Tooltip
            title={
              (!examListData.get('isEnable')
                ? defineMessages(formatMessage({ id: 'ExamListItem_15', defaultMessage: '[삭제된 대상자]' })) + ' '
                : '') +
              examListData.get('targetName') +
              ' (' +
              examListData.get('targetEmail') +
              ')'
            }
            classes={{ tooltip: 'tooltip-noMaxWidth' }}
            placement="bottom">
            <div className={cx('targetInfo')}>
              <Image src="/img/exam/chart/each_target.png" />
              <div className={cx('ellipsis')}>
                {/* <Icon name="user" /> */}
                {examListData.get('targetName') + ' (' + examListData.get('targetEmail') + ')'}
              </div>
            </div>
          </Tooltip>
        </Grid.Column>
        <Grid.Column className={cx('cell-company')} textAlign="left">
          <Tooltip
            title={
              defineMessages(formatMessage({ id: 'ExamListItem_13', defaultMessage: '소속' })) +
              ': ' +
              (!!examListData.get('targetDivision') ? examListData.get('targetDivision') : '-') +
              ' / ' +
              defineMessages(formatMessage({ id: 'ExamListItem_14', defaultMessage: '직급' })) +
              ': ' +
              (!!examListData.get('targetPosition') ? examListData.get('targetPosition') : '-')
            }
            classes={{ tooltip: 'tooltip-noMaxWidth' }}
            placement="bottom">
            <div className={cx('company-area', 'ellipsis')}>
              {(!!examListData.get('targetDivision') ? examListData.get('targetDivision') : '-') +
                ' / ' +
                (!!examListData.get('targetPosition') ? examListData.get('targetPosition') : '-')}
            </div>
          </Tooltip>
        </Grid.Column>
        <Grid.Column className={cx('cell-step')} textAlign="left">
          <div className={cx('step-area')}>
            <div
              className={cx(
                'step-title',
                {
                  'color-orange':
                    !!examListData.get('read') && !examListData.get('infection') && !examListData.get('download')
                },
                { 'color-down': !!examListData.get('download') && !examListData.get('infection') },
                { 'color-red': (!!examListData.get('infection') || sendFail) && !examListData.get('cure') },
                { 'color-cure': !!examListData.get('cure') }
              )}>
              {!!examListData.get('sendLog') ? (
                <Modal
                  dimmer="inverted"
                  className={cx('sendLogModal')}
                  trigger={
                    <Tooltip
                      title={defineMessages(
                        formatMessage({ id: 'ExamListItem_21', defaultMessage: "메일 발송 실패 이유 'click'" })
                      )}
                      onClick={e => {
                        e.stopPropagation();
                        sendLogData.onGetExamTarget(examListData.get('examNo'), examListData.get('targetNo'));
                      }}
                      classes={{ tooltip: 'tooltip-noMaxWidth' }}
                      placement="bottom">
                      <div className={cx('step-icon', 'send')}>
                        <Icon name="question circle outline" size="tiny" />
                        {stepText}
                      </div>
                    </Tooltip>
                  }
                  closeIcon>
                  <div>
                    {!!sendLogData.isLoading && <Loading content={'Loading...'} />}
                    <div className={cx('sendLogModal-title')}>
                      {defineMessages(formatMessage({ id: 'ExamListItem_22', defaultMessage: '발송 실패 사유' }))}
                    </div>
                    <div className={cx('sendLogModal-content')}>{sendLogData.logData.sendLog}</div>
                  </div>
                </Modal>
              ) : (
                stepText
              )}
            </div>
            {/* 대상 */}
            <ExamStep
              active={!!examListData.get('target')}
              title={defineMessages(formatMessage({ id: 'ExamListItem_3', defaultMessage: '대상' }))}
              stepType="target"
            />
            {/* 발송 */}
            <ExamStep
              active={!!examListData.get('send') || !!sendReserve || !!sendFail}
              title={sendTooltip}
              stepType="send"
              sendReserve={sendReserve}
              sendStop={sendStop}
              sendFail={sendFail}
            />
            {/* 열람 */}
            <ExamStep
              active={!!examListData.get('read') || !!examListData.get('download') || !!examListData.get('infection')}
              title={readTooltip}
              stepType="read"
              isMobile={examListData.get('readDeviceType') !== 1}
            />
            {/* 다운 */}
            {(2 & examListData.get('linkAttach') || isPhishing) && (
              <ExamStep
                active={!!examListData.get('download') || !!examListData.get('infection')}
                title={downTooltip}
                stepType={isPhishing ? 'access' : 'down'}
              />
            )}
            {/* 감염 */}
            <ExamStep
              active={!!examListData.get('infection')}
              title={infectionTooltip}
              stepType={isPhishing ? 'leak' : 'infection'}
            />
            {/* 치료 */}
            {1 === examSummaryData.get('examType') &&
              2 === examSummaryData.getIn(['attachData', 'attachExamType']) && (
                <ExamStep active={!!examListData.get('cure')} title={cureTooltip} stepType="cure" />
              )}
          </div>
        </Grid.Column>
        <Grid.Column className={cx('cell-infectionPc')}>
          {isPhishing ? (
            <div />
          ) : (
            <div className={cx('infectionPc-area')}>
              <InfectionPC
                pcCount={examListData.get('infectionPc')}
                leakCount={examListData.get('leakAllcount')}
                leakSize={common.fileSizeTrans(examListData.get('leakAllsize')).common}
              />
            </div>
          )}
        </Grid.Column>
        {commonVar.isDeclare === 1 && (
          <Grid.Column className={cx('cell-declare')}>
            <div className={cx('declare-area')}>
              <Tooltip
                title={
                  examListData.get('declare') > 0
                    ? defineMessages(formatMessage({ id: 'Declare_5', defaultMessage: '신고 일시' })) +
                      ': ' +
                      common.timeFormatFromUTCEpoch(examListData.get('declare'))
                    : defineMessages(formatMessage({ id: 'Declare_6', defaultMessage: '신고 안함' }))
                }
                classes={{ tooltip: 'tooltip-noMaxWidth' }}
                placement="bottom-end">
                <div className={cx('declare-box piDeclare', { existDeclare: examListData.get('declare') > 0 })}>
                  <span className={cx('declare-title')}>
                    <Image
                      src={
                        examListData.get('declare') > 0 ? '/img/declare/declare_on.png' : '/img/declare/declare_off.png'
                      }
                    />
                  </span>
                  <span>{defineMessages(formatMessage({ id: 'Declare_3', defaultMessage: '신고' }))}</span>
                </div>
              </Tooltip>
            </div>
          </Grid.Column>
        )}
        {commonVar.isEdu === 1 && (
          <Grid.Column className={cx('cell-edu')}>
            <div className={cx('edu-area')}>
              <Tooltip title={eduTooltip} classes={{ tooltip: 'tooltip-noMaxWidth' }} placement="bottom-end">
                <div className={cx('declare-box piEdu', { existEdu: existPlayEdu })}>
                  <span className={cx('edu-title')}>
                    <Image src={existPlayEdu ? '/img/edu/edu_on.png' : '/img/edu/edu_off.png'} />
                  </span>
                  <span>{eduText}</span>
                </div>
              </Tooltip>
            </div>
          </Grid.Column>
        )}
      </Grid.Row>
    );

    return (
      <Segment
        vertical
        className={cx('examListItem-wrapper', {
          selected:
            selectedExamList.get('isType') === 'select' && selectedExamList.get('noArray').indexOf(itemNo) !== -1
        })}
        onClick={e => {
          e.stopPropagation();

          // e.shiftKey
          handleSelectExamList(itemNo);
        }}>
        <Grid columns="equal" stackable style={{ padding: '2px 0px' }}>
          {InnerComponent}
        </Grid>
      </Segment>
    );
  }
}

export default injectIntl(ExamListItemPi);



// WEBPACK FOOTER //
// ./src/script/components/exam/ExamListItemPi.js